import { NAV_CHROME_BOOT_SCRIPT, NAV_CHROME_CRITICAL_CSS } from './navChromeBoot';

export const NAV_CHROME_BOOT_SCRIPT_ID = 'bz-nav-chrome-boot';
export const NAV_CHROME_CRITICAL_CSS_ID = 'bz-nav-chrome-critical-css';

export const NavChromeBootScript = () => (
  <>
    <style
      // eslint-disable-next-line benzinga/no-unsanitized-innerhtml -- static CSS; must run before first paint
      dangerouslySetInnerHTML={{ __html: NAV_CHROME_CRITICAL_CSS }}
      id={NAV_CHROME_CRITICAL_CSS_ID}
    />
    <script
      // eslint-disable-next-line benzinga/no-unsanitized-innerhtml -- static boot script; must run before first paint
      dangerouslySetInnerHTML={{ __html: NAV_CHROME_BOOT_SCRIPT }}
      data-cfasync="false"
      id={NAV_CHROME_BOOT_SCRIPT_ID}
    />
  </>
);
